import axios from 'axios';

export const getHeaders = () => {
    const token = localStorage.getItem('msal.idtoken');
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);
    // myHeaders.append("x-api-key", 'process.env.REACT_APP_X_API_KEY');
    myHeaders.append("Content-Type", "application/json");
    return myHeaders
}

// export const ApiService = (endPoint, method = 'GET', payload = '', resType = null) => {
//     console.log(resType, "Res type..........")

//     // let apiUrl = `${process.env.REACT_APP_BASE_API_ENDPOINT}/${endPoint}`;
//     let apiUrl = "https://hrsbacw62a.execute-api.us-east-1.amazonaws.com/dev/api" + endPoint;
//     if (method === 'GET' && payload) {
//         const queryParams = new URLSearchParams(payload).toString();
//         apiUrl = `${apiUrl}?${queryParams}`;
//     }

//     let requestOptions = {
//         method,
//         headers: getHeaders(),
//     };

//     // if (payload && method !== 'GET') {
//     //     requestOptions = { ...requestOptions, body: JSON.stringify(payload) };
//     // }


//     if (payload && method !== 'GET') {
//         if (payload instanceof FormData) {
//             requestOptions = { ...requestOptions, body: payload };
//             // Remove 'Content-Type' header to let the browser set it automatically
//             delete requestOptions.headers['Content-Type'];
//         } else {
//             requestOptions = { ...requestOptions, body: JSON.stringify(payload) };
//             requestOptions.headers['Content-Type'] = 'application/json';
//         }
//     }


//     if (resType !== null) {
//         return fetch(apiUrl, requestOptions).then((res) => res.text());
//     } else {
//         return fetch(apiUrl, requestOptions).then((res) => res.json());
//     }
// }

export const api = (endPoint, payload) => {
    try {
        const response = axios.post("http://localhost:8000" + endPoint, payload, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

    } catch (error) {
        console.error("Error: ", error)
    }

}

   export const fetchAPI = axios.create({
    // baseURL:"http://localhost:8000/api"
    // baseURL:"https://mvklx8zjuj.execute-api.us-east-1.amazonaws.com/dev/api/",
    // baseURL:"https://pc9h73jpdh.execute-api.us-east-1.amazonaws.com/prod/api/",
    baseURL:process.env.REACT_APP_BASE_API_ENDPOINT,
  });